<template>
  <v-container fluid class="login-hero app-background">
    <!-- Overlay for subtle gradient animations -->
    <div class="hero-overlay"></div>

    <v-row class="content-wrap" align="center" justify="center" no-gutters>
      <v-col cols="12" md="10" lg="8" xl="6">
        <!-- Floating Glass Card containing the entire login layout -->
        <v-card class="glass-card rounded-xl overflow-hidden shadow-soft main-glass-container" elevation="0">
          <v-row no-gutters>
            <!-- Columna izquierda: marca + formulario -->
            <v-col cols="12" md="6" class="px-6 px-md-10 py-10 left-pane d-flex flex-column justify-center">
              <div class="pane-inner">
                <!-- Marca -->
                <div class="brand-title mb-8 text-center text-md-left">
                  <span class="brand-infos">Lottery</span><span class="brand-soft">BestOne</span>
                  <div class="text-subtitle-1 font-weight-medium mt-2 text-grey">Bienvenido de nuevo</div>
                </div>

                <!-- Formulario -->
                <v-form ref="form" v-model="valid" @submit.prevent="log">
                  <v-text-field
                    v-model="user.cedula"
                    label="Usuario"
                    placeholder="Ingrese su usuario"
                    outlined
                    rounded
                    dense
                    hide-details="auto"
                    class="mb-4 modern-input"
                    prepend-inner-icon="mdi-account-circle"
                    :rules="requiredRules"
                    required
                    @keyup.enter="log"
                  />

                  <v-text-field
                    v-model="user.clave"
                    :type="showPass ? 'text' : 'password'"
                    label="Contraseña"
                    placeholder="Ingrese su contraseña"
                    outlined
                    rounded
                    dense
                    hide-details="auto"
                    class="mb-6 modern-input"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPass = !showPass"
                    :rules="requiredRules"
                    required
                    @keyup.enter="log"
                  />

                  <!-- Botones -->
                  <div class="btn-row mt-6">
                    <v-btn
                      large
                      rounded
                      dark
                      color="primary"
                      class="px-8 shadow-soft font-weight-bold login-btn"
                      :disabled="!valid || loading"
                      :loading="loading"
                      @click="log"
                      elevation="3"
                    >
                      Ingresar
                      <v-icon right>mdi-login-variant</v-icon>
                    </v-btn>

                    <v-btn
                      large
                      rounded
                      class="px-8 more-info-btn font-weight-bold"
                      color="#162a4f"
                      dark
                      elevation="2"
                      @click="moreInfo"
                    >
                      Más información
                    </v-btn>
                  </div>
                </v-form>

                <!-- Disclaimer -->
                <p class="disclaimer mt-8 text-center text-md-left">
                  BestOne Solutions alquila un sistema de venta de tiempos con el propósito de facilitar las transacciones entre vendedores y banqueros.
                </p>
              </div>
            </v-col>

            <!-- Columna derecha: imagen -->
            <v-col cols="12" md="6" class="right-pane d-none d-md-flex align-center justify-center pa-8 flex-column" style="background: rgba(25, 118, 210, 0.03);">
              <v-img
                contain
                max-width="85%"
                class="mx-auto floating-img logo-glow"
                src="@/assets/pngegg.png"
                alt="Lottery balls"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <Snackbar :text="snackText" :snackbar="snackValue" />
  </v-container>
</template>

<script>
import axios from "axios";
import Snackbar from "../components/shared/Snackbar.vue";
import { mapMutations } from "vuex";

export default {
  components: { Snackbar },
  data() {
    return {
      showPass: false,
      valid: false,
      loading: false,
      snackValue: false,
      snackText: "",
      user: {
        cedula: "",
        clave: "",
        nombre: "",
      },
      requiredRules: [(v) => !!v || "Campo requerido"],
    };
  },
  methods: {
    ...mapMutations(["setUser"]),
    async log() {
      if (!this.valid || this.loading) return;
      this.loading = true;
      try {
        const { data } = await axios.get(
          `/api/Usuarios/isValidUser?cedula=${encodeURIComponent(
            this.user.cedula
          )}&clave=${encodeURIComponent(this.user.clave)}`
        );
        if (data) {
          this.setUser(data);
          this.$router.replace({ name: "Dashboard" });
        } else {
          this.snackText = "Credenciales Incorrectas";
          this.snackValue = true;
        }
      } catch (err) {
        console.error(err);
        this.snackText = "Error al Validar Credenciales";
        this.snackValue = true;
      } finally {
        this.loading = false;
      }
    },
    moreInfo() {
      window.open("https://wa.link/be68q6", "_blank");
    },
  },
};
</script>

<style scoped>
/* Global Application Background for Login */
.app-background {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

/* Oscuro opcional para el futuro, aunque Login usualmente carga Light mode primero */
.theme--dark .app-background {
  background: linear-gradient(135deg, #1e1e2e 0%, #11111b 100%) !important;
}

/* Optional Overlay for depth */
.hero-overlay {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at center, rgba(255,255,255,0.4) 0%, transparent 60%);
  pointer-events: none;
  animation: slowSpin 40s linear infinite;
  z-index: 1;
}

.theme--dark .hero-overlay {
  background: radial-gradient(circle at center, rgba(25,118,210,0.1) 0%, transparent 60%);
}

@keyframes slowSpin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* Centra todo el layout en la pantalla */
.login-hero {
  min-height: 100vh;
  display: flex !important;
  align-items: center !important;
}

/* Ancho máximo del contenido */
.content-wrap {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

/* Glassmorphism Classes */
.glass-card {
    background: rgba(255, 255, 255, 0.75) !important;
    backdrop-filter: blur(20px) !important;
    -webkit-backdrop-filter: blur(20px) !important;
    border: 1px solid rgba(255, 255, 255, 0.5) !important;
}

.theme--dark .glass-card {
    background: rgba(30, 30, 46, 0.75) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.main-glass-container {
    animation: fadeInScale 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    opacity: 0;
    transform: translateY(20px) scale(0.98);
}

@keyframes fadeInScale {
    to { opacity: 1; transform: translateY(0) scale(1); }
}

/* Modern Inputs */
.modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(255, 255, 255, 0.6) !important;
    backdrop-filter: blur(4px);
    transition: all 0.3s ease;
}

.modern-input >>> .v-input__control > .v-input__slot:hover {
    background: rgba(255, 255, 255, 0.9) !important;
    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);
}

.theme--dark .modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(0, 0, 0, 0.2) !important;
}

.theme--dark .modern-input >>> .v-input__control > .v-input__slot:hover {
    background: rgba(0, 0, 0, 0.4) !important;
}

/* Utilities */
.shadow-soft {
  box-shadow: 0 8px 30px rgba(0,0,0,0.08) !important;
}

.logo-glow {
  filter: drop-shadow(0 15px 25px rgba(0,0,0,0.15));
}

.theme--dark .logo-glow {
  filter: drop-shadow(0 15px 25px rgba(255,255,255,0.05));
}

.text-grey {
  color: #64748b !important;
}

.theme--dark .text-grey {
  color: #94a3b8 !important;
}

.floating-img {
    animation: float 6s ease-in-out infinite;
}

@keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-15px); }
    100% { transform: translateY(0px); }
}

/* Limita y centra el bloque izquierdo */
.pane-inner {
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
}

/* Marca */
.brand-title {
  font-weight: 900;
  line-height: 1.1;
  font-size: clamp(32px, 4vw, 42px);
  letter-spacing: -0.5px;
}
.brand-infos { color: #1976D2; }
.brand-soft  { color: #0f1e3a; }
.theme--dark .brand-soft { color: #ffffff; }

/* Botones */
.login-btn {
    transition: all 0.3s ease;
}
.login-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(25, 118, 210, 0.3) !important;
}

.more-info-btn { 
    transition: all 0.3s ease;
}
.more-info-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(22, 42, 79, 0.3) !important;
}

.btn-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

/* Ajuste para móviles */
@media (max-width: 600px) {
  .btn-row {
    flex-direction: column;
    gap: 12px;
  }
}

/* Disclaimer */
.disclaimer {
  max-width: 100%;
  font-size: 0.85rem;
  color: #64748b;
  line-height: 1.5;
}

.theme--dark .disclaimer {
  color: #94a3b8;
}
</style>